import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="display-teaching-info"
export default class extends Controller {
  static targets = [ 'teachingIdField', 'openSeasonTerm', 'place', 'openCourseTerm', 'openCourseDays', 'courseName', 'teacherName' ]
  static values = {
    teachingSearchUrl: String,
  }

  connect() {
    const teachingId = this.teachingIdFieldTarget.value
    this.fetchTeachingSearch(teachingId)
  }

  changeTeachingInfo(event) {
    const teachingId = event.target.value
    this.fetchTeachingSearch(teachingId)
  }

  fetchTeachingSearch(teachingId) {
    if (!teachingId) {
      this.resetTeachingInfo()
      return
    }

    const query = new URLSearchParams()
    query.set('q[id_eq]', teachingId)
    fetch(`${this.teachingSearchUrlValue}?${query}`)
      .then(response => response.json())
      .then(data => {
        if (data[0]) {
          this.openSeasonTermTarget.innerHTML = data[0].open_season_term
          this.placeTarget.innerHTML = data[0].place
          if (this.hasOpenCourseTermTarget) {
            this.openCourseTermTarget.innerHTML = data[0].open_course_term
          }
          if (this.hasOpenCourseDaysTarget) {
            this.openCourseDaysTarget.innerHTML = data[0].open_course_days
          }
          this.teacherNameTarget.innerHTML = data[0].teacher_name
          this.courseNameTarget.innerHTML = data[0].course_name
        } else {
          this.resetTeachingInfo()
        }
      })
  }

  resetTeachingInfo() {
    this.openSeasonTermTarget.innerHTML = ''
    this.placeTarget.innerHTML = ''
    if (this.hasOpenCoursTermTarget) {
      this.openCourseTermTarget.innerHTML = ''
    }
    if (this.hasOpenCourseDaysTarget) {
      this.openCourseDaysTarget.innerHTML = ''
    }
    this.teacherNameTarget.innerHTML = ''
    this.courseNameTarget.innerHTML = ''
  }
}
